import { render, staticRenderFns } from "./elegant.vue?vue&type=template&id=64d489bb&scoped=true"
import script from "./elegant.vue?vue&type=script&lang=js"
export * from "./elegant.vue?vue&type=script&lang=js"
import style0 from "./elegant.vue?vue&type=style&index=0&id=64d489bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d489bb",
  null
  
)

export default component.exports